import { useEffect } from 'react';
import { STUDIO_GENDER_ASSETS } from '../constants/studioGenderAssets';
import { STUDIO_OPTIONS_BY_STEP } from '../constants/studioOptions';
import { preloadImages } from '../utils/preloadStudioAssets';

const GENDER_IMAGE_URLS = STUDIO_GENDER_ASSETS.map(({ image }) => image);

const collectStepImageUrls = (stepKey, gender) => {
	const pool = STUDIO_OPTIONS_BY_STEP[stepKey];
	const options = pool?.[gender] ?? [];

	return options.map((option) => option.image).filter(Boolean);
};

export const useStudioAssetPreload = ({ step, gender }) => {
	useEffect(() => {
		preloadImages(GENDER_IMAGE_URLS);
	}, []);

	useEffect(() => {
		if (step === 'gender') {
			preloadImages(collectStepImageUrls('ethnicity', gender));
			return;
		}

		const currentIndex = [
			'ethnicity',
			'hairstyle',
			'haircolor',
			'bodytype',
			'eyecolor',
			'intimatesize',
		].indexOf(step);

		if (currentIndex === -1) {
			return;
		}

		const nextSteps = [
			'ethnicity',
			'hairstyle',
			'haircolor',
			'bodytype',
			'eyecolor',
			'intimatesize',
		].slice(currentIndex + 1, currentIndex + 2);

		nextSteps.forEach((nextStep) => {
			preloadImages(collectStepImageUrls(nextStep, gender));
		});
	}, [step, gender]);
};
